import { gql } from "@apollo/client";

export const CERTIFICATE_FIELDS = gql`
  fragment CertificateFields on Certificate {
    id
    firstname
    lastname
    personal_number
    date
    author {
      id
      name
      type
    }
    principal
    # principal {
    #   id
    #   email
    #   firstname
    #   lastname
    #   type
    # }
    educator {
      id
      name
      title
      status
      certified
      parentGroups {
        id
        name
        title
        logo2 {
          id
          title
          filename
          filesize
          filetype
          url
        }
        parentGroups {
          id
          name
          title
          logo2 {
            id
            title
            filename
            filesize
            filetype
            url
          }
        }
      }
    }
    credits
    done
    created_at
    updated_at
    uid {
      id
      code
      created_at
    }
  }
`;

export const GET_CERTIFICATE = gql`
  query Certificate($id: ID!) {
    certCertificate(id: $id) {
      ...CertificateFields
    }
  }
  ${CERTIFICATE_FIELDS}
`;

export const GET_CERTIFICATES = gql`
  query Certificates(
    $search: String
    $page: Int
    $limit: Int
    $orderBy: [GetCertificatesOrderByClause]
    $filters: [GetCertFilter]
  ) {
    certCertificates(
      search: $search
      page: $page
      limit: $limit
      orderBy: $orderBy
      filters: $filters
    ) {
      paginatorInfo {
        total
        currentPage
        hasMorePages
      }
      data {
        ...CertificateFields
      }
    }
    allGroups(categories: ["educator"]) {
      id
      title
      parentGroups {
        logo3 {
          id
          title
          url
        }
      }
    }
  }
  ${CERTIFICATE_FIELDS}
`;
